export const environment = {
    appName: 'Bewell Corporation',
    timezone: 'Asia/Manila',
    basePath: 'https://bewell.com.ph',
    apiUrl: 'https://cms-api.bewell.com.ph',
    turnstileSiteKey: '0x4AAAAAAED51kHOkwjLytsG'
};